import { RightCircleFilled } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { Store } from 'antd/lib/form/interface';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import AnchorComponent from 'components/atoms/AnchorComponent';
import ButtonComponent from 'components/atoms/ButtonComponent';
import InputPassword from 'components/atoms/InputPassword';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import AuthWrapper from 'components/base/AuthWrapper';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';

import { useNewPassword } from 'hooks/useNewPassword';

import { leiMigracePasswordApi } from 'services/lei/leiLogin';

import routePathEnum from 'enums/routePathEnum';

import passwordCheckValidation from 'utils/validations/passwordCheckValidation';

interface IObnoveniHesla {}

const ObnoveniHesla: React.FC<IObnoveniHesla> = () => {
    const [form] = useForm();
    const { PasswordInput, isStrongEnough } = useNewPassword('password');
    const { id } = useParams<{ id: string }>();
    const [loading, setLoading] = useState<boolean>(false);
    const [status, setStatus] = useState<number>(0);
    const onFinish = ({ password }: Store) => {
        setLoading(true);
        leiMigracePasswordApi({
            initcode: id!,
            heslo: password
        })
            .then(resp => setStatus(resp))
            .catch(err => setStatus(err.response.status))
            .finally(() => {
                setLoading(false);
            });
    };
    const okReturn = () => (
        <div
            style={{
                textAlign: 'center'
            }}
        >
            <Row>
                <Col span={24}>
                    <Title text="EMP_INFO_ZMENA_OBNOVENI_HESLO" level={4} />
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <TranslateText>EMP_POTVRZENI_EMAIL_200</TranslateText>
                </Col>
            </Row>
            <AnchorComponent link={true} to={routePathEnum.LEI_LOGIN_AKTUALIZACE}>
                <ButtonComponent buttontext="ZPET" type="default" id="zpetBtn" />
            </AnchorComponent>
        </div>
    );

    const errReturn = () => (
        <Row justify="center">
            <AnchorComponent link={true} to={routePathEnum.ZADOST_OBNOVENI_HESLA_LEI}>
                <TranslateText>HESLO_ZMENA_401</TranslateText>
            </AnchorComponent>
        </Row>
    );

    const defaultReturn = () => (
        <FormWrapper onFinish={onFinish} outForm={form}>
            <Title text="ZAPOMENUTE_HESLO_LEI_TITLE2" level={3} />
            <Paragraph
                text="ZAPOMENUTE_HESLO_LEI_SUB2"
                style={{
                    display: 'block',
                    marginBottom: 10
                }}
            />
            {PasswordInput()}
            <InputPassword
                label="HESLO_NOVE_OVERENI"
                name="passwordCheck"
                type="password"
                dependencies={['password']}
                rules={passwordCheckValidation('password')}
            />
            <ButtonComponent
                buttontext="POKRACOVAT"
                id="pokracovatBtn"
                disabled={!isStrongEnough}
                onClick={() => form.submit()}
                icon={<RightCircleFilled />}
                loading={loading}
            />
        </FormWrapper>
    );

    return (
        <AuthWrapper>
            {(!status || (status !== 200 && status !== 401)) && defaultReturn()}
            {status === 200 && okReturn()}
            {status === 401 && errReturn()}
        </AuthWrapper>
    );
};

export default ObnoveniHesla;
